/**
 * 申请下载弹框组件
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../base/BaseComponent";
import {Button, Modal,Input} from "antd";
import {uuid} from "../../../utils";
import {message} from './Mess'
import CmForm from "../../../components/CmForm/CmForm";
import ActivitiModal from "../../editor/components/activitiAndBtn/ActivitiModal";
import SyncModal from "../../components/syncModal/syncModal";
import {Scrollbars} from "react-custom-scrollbars";
const { TextArea } = Input;
export default class Apply extends BaseComponent {
    static defaultProps = {
        backList:[]
    };
    static propTypes = {
        backList:PropTypes.array.isRequired,//返回数组
    };

    constructor(props) {

        super(props);
        this.state={
            apply:false, //申请下载弹框
            data:{},//要查看审核的当前数据
            dataSource:[],//数据源
            previewVisible:false, //控制图片弹框的显示
            current:{},//查看图片 当前图片
            activityOption: {},
            showRemarks:false,
            activitiConfName: this.sysConfigGetValueByKey("activitiTreeRoot-other-sourceDownload", "activitiTreeRoot-other-sourceDownload"),
        }
    }
    componentWillMount() {
        this.initActivitiConfig({});
    }

    /**设置流程配置*/
    initActivitiConfig() {
       let {data} = this.state;
        let id = (data.id && data.id.length > 1 && data.id != 'null' && data.id != 'undefined') ? data.id : '';
      
        let that = this;
        let account = (window.currentUser && window.currentUser.account) ? window.currentUser.account : "";
        this.state.activityOption = {
            id: id,//流程id
            activitiConf: this.state.activitiConfName ? {type: this.state.activitiConfName} : null,//流程conf
            pojoName: 'zyxzsq',//数据表name
            userAccount: account,//当前用户account
            showBtnFlag: true,//是否显示流程按钮
            againFlag: false,//重置流程的判断条件
            showAfterFuns: {},//流程按钮加载前置js
            getTextRequisite: false,//备注是否必填
            otherJs: {
                setSourceUser: (activiti, buttonConf, call) => {
                    try {
                        activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                            id: this.webStory.creator,
                            name: this.webStory.creatorName
                        }];
                        call({code: 1, log: "查询到返回者为：" + this.webStory.creator});
                    } catch (e) {
                        message.error(e);
                        throw e;
                    }
                },
                /**
                 * 撤稿前置js
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                callActRevert: function (activiti, buttonConf, call) {
                    activiti.terminate.call(activiti, function (res) {
                        if (res == true) {
                            activiti.options.statusNameTemp = "草稿";
                            activiti.endFunction(activiti, function (res) {
                                if(res.status){
                                    message.success("撤回成功！");
                                    activiti.submitOK();
                                }
                            })
                        }
                    });
                },
            },//流程按钮点击事件前置js
            saveFunction: that.saveData,//稿件保存方法
            saveStatusNameFunction: that.updateStatusName,//稿件改流程状态方法
            onSubmitOK: function (activiti) {
                window.loading.hide();
                that.onCancel()
            },//流程事件运行完毕的回调
            successCall: () => {
            },//流程加载完的回调

            successMsg:()=>{
                message.success('操作成功', 1);
                that.props.callBackData&&that.props.callBackData();
            },
            readyCall: () => {
            },//流程初始化完的回调
            onlyShowBtn: true,//是否只返回流程按钮
            title: '',//流程弹窗title
            visible: false,//流程弹窗是否展示
            btnLoadOver:(btns)=>{
                this.activitiBtns = btns;
                this.setState({});
            },
            showRemarks: (remarks) => {
                if(remarks && remarks.length) {
                    this.setState({showRemarks:true,remarks})
                }
            },//备注回显
            // 控制前端发布按钮的显隐
            mustNotShowPublishBtn: true,
            showBtnIcon: false,
            btnType: "primary",
             checkForm:that.checkForm,
        };

        this.setState({});
    }
    componentDidMount() {

    }


    modalKey = uuid();
    show(refreshKey,data,currentName){
        // this.initActivitiConfig({});
        if(refreshKey){
            this.modalKey = uuid();
            this.state.apply =true;
            if(this.props.title ==='查看申请') {
                this.state.data =data;

                this.setState({}, () => {
                    this.initActivitiConfig(data);
                    this.getData()
                })
            }else{
                this.state.data ={};
                this.state.dataSource=data;
                this.setState({},()=>{
                    this.initActivitiConfig({});
                })
            }
        }else{
            this.setState({apply:false})
        }
    }

    onCancel=()=>{
        this.setState({apply:false,showRemarks:false});
        this.props.callBackData && this.props.callBackData();
    };
    render() {
     let foot= <div>
         <Button onClick={()=>{
            this.onCancel()
         }}>关闭</Button>
         <ActivitiModal
             {
                 ...this.state.activityOption
             }
         />
         {this.renderOtherBtn()}
         <SyncModal ref={ref=>this.syncModal=ref}/>
     </div>;
         if(this.props.name ==='待我审核'){
             foot= <div>
                 <Button style={{margin: "0px 12px"}} onClick={()=>{
                     this.setState({apply:false});
                     this.props.empty&&this.props.empty()
                 }}>取消</Button>
                 {this.state.apply? <ActivitiModal
                     {
                         ...this.state.activityOption
                     }
                 />:null}
             </div>
         }

        if(this.props.title === '新增申请'){
            foot= <div>
                <Button onClick={()=>{
                this.setState({apply:false})
            }}>取消</Button>
                {this.state.apply? <ActivitiModal
                    {
                        ...this.state.activityOption
                    }
                />:null}
        </div>
        }
        return (
            <div>
                <Modal
                    maskClosable={false}
                    keyboard={true}
                    title={this.props.title}
                    centered
                    key={this.modalKey}
                    width={'800px'}
                    visible={this.state.apply}
                    onCancel={()=>{
                       this.onCancel()
                    }}
                    footer={foot}
                >
                    <CmForm onSubmit={() => {
                        if(this.props.title === '新增申请'){
                            this.saveData()
                        }
                    }}>
                    <div>
                        <div style={{display:'flex'}}>
                            <div style={{width:'12%'}}><span style={{color:'red',marginRight:5}}>*</span>申请原因：</div>
                            <div style={{width:'83%'}}>
                                <TextArea rows={4}   disabled={this.props.disabled} placeholder={'请输入申请原因'} maxLength={500} value={this.state.data&&this.state.data.applyReason?this.state.data.applyReason:''} onChange={(e)=>{
                                    this.state.data.applyReason = e.target.value;
                                    this.setState({})
                                }}/>

                            </div>
                        </div>
                        <div style={{display:'flex',marginTop:'24px'}}>
                            <div  style={{width:'12%',textAlign: 'center'}}>
                                <div>资源</div>
                                <div>(共{this.state.dataSource.length}个)</div>
                            </div>
                            <Scrollbars autoHeight autoHide autoHeightMax={500}>
                                <div style={{display:'grid',fontSize:'14px',textAlign: 'center',flexWrap: 'wrap',width:'83%',justifyContent: 'space-between',gridTemplateColumns:' repeat(auto-fill, 110px)',}}>
                                    {this.state.dataSource&&this.state.dataSource.length&&this.state.dataSource.map((item,index)=>{
                                        if(item.fileTypeEnum === "FILE"){
                                            return(
                                                <div style={{color: 'rgba(0, 0, 0, 0.65)',width:'90px'}} key={index}>
                                                    <img src ={item.icon} style={{width:88,height:88,objectFit: 'contain'}}/>
                                                    <div className={'theretext'} style={{cursor:'pointer'}} title={item.name}>{item.name}</div>
                                                    <div>{((item.size) / (1024 * 1024)).toFixed(2)+'M'}</div>
                                                </div>
                                            )
                                        }
                                    })}
                                </div>
                            </Scrollbars>

                        </div>
                        {/*{*/}
                        {/*    this.props.title === '查看申请'&&this.state.data.status==='不通过'?<div style={{display:'flex',marginTop:'24px'}}>*/}
                        {/*        <div style={{width:'12%'}}>未通过原因：</div>*/}
                        {/*        <div style={{width:'83%',color:'red'}}>{this.state.data&&this.state.data.failureReason?this.state.data.failureReason:''}</div>*/}
                        {/*    </div>:null*/}
                        {/*}*/}
                    </div>
                    </CmForm>
                </Modal>
            </div>

        )
    }

    renderOtherBtn = () => {
        let actButtons = [];
        if(this.state.showRemarks){
            actButtons.push(<Button
                key={uuid()}
                type={"primary"}
                onClick={this.showRemarksCall}
                style={{margin: "0 12px"}}>查看备注</Button>);
        }
        return actButtons
    };

    // 查看备注
    showRemarksCall = () =>{
        let that = this;
        that.syncModal.confirm({
            title: "备注",
            width: 400,
            content: <TextArea value={that.state.remarks} placeholder={"请输入"} maxLength={200} rows={2}
                               style={{width: 350, height: 64, fontSize: 14}}
                               ref={(remarksTextArea) => that.remarksTextArea = remarksTextArea}/>,
            okText: "确定",
            cancelText: "取消",
            onOk: () => {
                that.syncModal.destroy();
            },
            footer: <Button onClick={()=>{that.syncModal.destroy();}}>关闭</Button>,
            onCancel: () => {
                that.syncModal.destroy();
            }
        });
    }

    /**
     *申请下载修改状态
     */
    updateStatusName=(statusName, activiti, call)=> {
        this.request({
            url: '/cm-sites-storage-management/applyForResource/saveStatusName',
            method: 'POST',
            body:{
                "id": this.state.data.id,
                "status":statusName,
            },
            contentType:'json',
            callBack: function (res) {
                if (res) {
                    call&&call({status: true, msg: "流程推进后状态修改成功。"});
                } else {
                    call&&call({status: false, msg: "流程推进后状态修改失败。"});
                }
            },
            errorCallBack: function (res) {
                call&&call({status: false, msg: "流程推进后状态修改失败。"});
            }
        });
    };

    //获取数据列表
    getData(){
        this.request({
            url: "/cm-sites-storage-management/applyForResource/getById",
            method: "get",
            body:{id:this.state.data.id},
            contentType: "json",
            callBack: (data) => {
                if(data&&data.virtualFileList){
                 this.setState({dataSource:data.virtualFileList},()=>{
                 })
                }
            }
        });
    }


    checkForm=(activiti,call)=>{
        if(!this.state.data.applyReason){
            window.loading.hide();
            message.error('请填写申请原因！');
            return false
        }
        call&&call()
    };
    saveData=(activiti, callback)=>{
        let ids= [];
        this.state.dataSource&&this.state.dataSource.length&&this.state.dataSource.forEach((item,index)=>{
                ids.push(item.id)
        });
        let deptList = window.currentUser.deptList;
        let depName = [];
         deptList&&deptList.length&&deptList.forEach((item,index)=>{
            depName.push(item.name)
        });

        // List<VirtualFile> virtualFileList;
        let params={
            userId:this.state.data&&this.state.data.userId?this.state.data.userId:window.currentUser.id,
            userName:this.state.data&&this.state.data.userName?this.state.data.userName:window.currentUser.name,
            deptId:this.state.data&&this.state.data.deptId?this.state.data.deptId:window.currentUser.deptIds,
            deptName:this.state.data&&this.state.data.deptName?this.state.data.deptName:depName,
            applyNum: this.state.dataSource.length,
            virtualFileIds:ids,
            status: activiti.options.statusNameTemp,
            applyReason: this.state.data.applyReason,
            failureReason:this.state.data.failureReason

        };
        if(this.props.name ==='待我审核'){
            params.reviewerUserId =  window.currentUser.id;
        }
        if(this.state.data&&this.state.data.id){
            params.id = this.state.data.id
        }
        this.request({
            url: "/cm-sites-storage-management/applyForResource/save",
            method: "post",
            body:params,
            contentType: "json",
            callBack: (data) => {
               if(data){

                   this.setState({apply:false,data:data});
                   callback(data)
               }
            }
        });
    }
}